import {createSlice} from '@reduxjs/toolkit';
import moment from 'moment';
import { rowsPerPageJsonData } from '../utils/JsonData';


//here just create for miscellaneousChargesList


const initialState = {
    searchFilters:{
        searchText: "",
        roomStatus: 0,
        houseKeepingStatus: 0,
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
    },
    houseKeepingsDataGridOptions: {
        loading: false,
        rows: [],
        totalRows: 0,
        rowsPerPageOptions: rowsPerPageJsonData,
        pageSize: 50,
        page: 1,
      },
    ImagesDialogList: [],
    houseKeeperList: [],
    cleaningList: [],


    };

const housekeepingSlice = createSlice({
    name: 'housekeeping',
    initialState: initialState,
    reducers: {
        houseKeepingsDataGridOptionsSucces: (state, action) => {
        state.houseKeepingsDataGridOptions = {...state.houseKeepingsDataGridOptions, [action.payload.key]: action.payload.value}
        },
        searchFiltersSuccess: (state, action) => {
        state.searchFilters = {...state.searchFilters, [action.payload.key]: action.payload.value}
        },
        ImagesDialogListSuccess: (state, action) => {
        state.ImagesDialogList = action.payload;
        },
        houseKeeperListSuccess: (state, action) => {
        state.houseKeeperList = action.payload;
        },
        cleaningListSuccess: (state, action) => {
        state.cleaningList = action.payload;
        },
    }
});

export const {
    houseKeepingsDataGridOptionsSucces,
    searchFiltersSuccess,
    ImagesDialogListSuccess,
    houseKeeperListSuccess,
    cleaningListSuccess,
} = housekeepingSlice.actions;

export default housekeepingSlice.reducer;
